import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { RowDialogComponent } from '../row-dialog/row-dialog.component';
import { CommonDimensions } from 'src/app/models/collection.interface';

interface CustomCellRendererParams extends ICellRendererParams {
  adminMode: boolean;
  onRowUpdate?: (fileId: string, updatedData: Partial<CommonDimensions>) => void;
}
@Component({
  selector: 'app-row-details',
  templateUrl: './row-details.component.html',
  styleUrl: './row-details.component.scss'
})
export class RowDetailsComponent implements ICellRendererAngularComp {
  dialog = inject(MatDialog);
  params = {} as CustomCellRendererParams;
  adminMode = false;

  // Params are passed in by ag-Grid
  agInit(params: CustomCellRendererParams): void {
    this.params = params;
    this.adminMode = params.adminMode || false;
  }

  refresh(): boolean {
    return false;
  }

  onClick(): void {
    const dialogRef = this.dialog.open(RowDialogComponent, {
      width: '1000px',
      data: {
        dimensions: this.params.data,
        adminMode: this.adminMode
      }
    });

    // Handle dialog result for admin mode
    if (this.adminMode) {
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.action === 'save') {
          this.handleSaveChanges(result.data);
        }
      });
    }
  }

  private handleSaveChanges(editedData: Partial<CommonDimensions>): void {
    if (!this.params.onRowUpdate) {
      console.warn('No onRowUpdate callback provided');
      return;
    }
    if (!this.params.data.file_id) {
      console.warn('Missing file_id in data');
      return;
    }
    this.params.onRowUpdate(this.params.data.file_id, editedData);
  }
}
